import setRef from '@mui/utils/setRef';
export default setRef;


//////////////////
// WEBPACK FOOTER
// ../@mui/material/utils/setRef.js
// module id = 1790
// module chunks = 25